import { Link } from '@mm/components';
import { Alert } from 'antd';
import React from 'react';

export const DisabledTagsMessage = () => (
  <Alert
    message={
      <div>
        <strong>Warning:</strong> Tags are disabled for this Salesforce account.
        <br />
        <Link
          href="https://help.salesforce.com/s/articleView?id=sf.customize_tag_settings.htm&type=5"
          isBlank
          capitalize={false}
        >
          {' '}
          How to enable tags?
        </Link>
      </div>
    }
    type="warning"
    showIcon
  />
);
